module.exports = __webpack_public_path__ + "media/images/sp/specials/common/recommend_2022_nenga-ad9632cc802b38ab94b9ece53bcb3daa.jpg";